import React from 'react';
import { connect } from 'react-redux';
import { change as formChange, touch as formTouch, getFormValues } from 'redux-form';
import { debounce } from 'lodash';
import axios from 'axios';
import { withTranslation } from 'react-i18next';
import { TextField, SelectField, Label, DoubleTextField } from 'src/jbc-front/components/Form';
import { CLIENT_FORM } from 'src/constants/FormNames';
import { isCorporateNumber, isEnglish, isEmpty, isPostalCode, isSocialSecurityNumber } from 'src/utils/CustomValidators';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { TelFieldTh } from 'src/components';

class ClientSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      regionalTaxOffices: [],
      taxOffices: [],
      provinces: [],
      ssoOffices: [],
      subdistricts: [],
      regions: []
    };

    this._loadSelectOptions = this._loadSelectOptions.bind(this);
    this._handleProvinceChange = this._handleProvinceChange.bind(this);
    this._handleRegionalTaxOfficeChange = this._handleRegionalTaxOfficeChange.bind(this);

    this.fetchTelNumber = this.fetchTelNumber.bind(this);
  }

  componentDidMount() {
    this._loadSelectOptions();
  }

  _getLocalizedLabel(element) {
    return this.props.i18n.language === 'vi' ? element.label : element.labelEn;
  }
  _loadSelectOptions() {
    const regionArr = [];
    this.props.regions.forEach(element => {
      regionArr.push({
        value: element.value,
        label: element.label
      });
    });

    const provincesArr = [];
    if (this.props.provinces && Array.isArray(this.props.provinces)) {
      this.props.provinces.forEach(element => {
        provincesArr.push({
          value: element.value,
          label: this._getLocalizedLabel(element)
        });
      });
    }

    this.setState(
      {
        provinces: provincesArr,
        regions: regionArr
      },
      () => {
        this._handleFilteredAddress(this.props.values?.client?.provinceId);
      }
    );
  }

  _handleFilteredAddress(provinceId) {
    const filteredSubdistricts = this.props.subdistricts[provinceId] || [];
    const provincialRegionalTaxOffices = this.props.regionalTaxOffices[provinceId] || [];
    const specialTaxOffices = this.props.regionalTaxOffices[''] || [];
    const filteredSsoOffices = this.props.ssoOffices[provinceId] || [];

    const subdistrictArr = filteredSubdistricts.map(element => ({
      value: element.value,
      label: this._getLocalizedLabel(element)
    }));

    const allRegionalTaxOffices = [...provincialRegionalTaxOffices, ...specialTaxOffices];
    const regionalTaxOfficesArr = allRegionalTaxOffices.map(element => ({
      value: element.value,
      label: element.label,
      taxOfficeCode: element.taxOfficeCode
    }));

    const ssoOfficesArr = filteredSsoOffices.map(element => ({
      value: element.value,
      label: this._getLocalizedLabel(element)
    }));

    this.setState(
      {
        subdistricts: subdistrictArr,
        regionalTaxOffices: regionalTaxOfficesArr,
        ssoOffices: ssoOfficesArr
      },
      () => {
        const regionalTaxOfficeCode = this.props.values?.client?.regionalTaxOfficeInformation?.taxOfficeCode;
        this._handleRegionalTaxOfficeChange(regionalTaxOfficeCode);
      }
    );
  }

  _handleRegionalTaxOfficeChange(regionalTaxOfficeCode) {
    if (this.state.currentRegionalTaxOfficeCode === regionalTaxOfficeCode) {
      return;
    }

    const allTaxOffices = Object.values(this.props.taxOffices).flat();
    const filteredTaxOffices = allTaxOffices.filter(
      element => element.parentTaxOfficeCode === regionalTaxOfficeCode || element.taxOfficeCode === regionalTaxOfficeCode
    );

    const taxOfficesArr = filteredTaxOffices.map(element => ({
      value: element.value,
      label: element.label
    }));

    this.setState({
      taxOffices: taxOfficesArr,
      currentRegionalTaxOfficeCode: regionalTaxOfficeCode
    });
  }

  fetchTelNumber(telNumber) {
    this.props.dispatch(formChange(CLIENT_FORM, 'client.telNumber', telNumber));
  }

  _handleProvinceChange(provinceId) {
    if (!provinceId) {
      this.setState({ subdistricts: [], regionalTaxOffices: [], taxOffices: [], ssoOffices: [] });
      return;
    }

    this.props.dispatch(formChange(CLIENT_FORM, 'client.subdistrictId', null));
    this.props.dispatch(formChange(CLIENT_FORM, 'client.regionalTaxOfficeId', null));
    this.props.dispatch(formChange(CLIENT_FORM, 'client.taxOfficeId', null));
    this.props.dispatch(formChange(CLIENT_FORM, 'client.ssoOfficeId', null));

    this._handleFilteredAddress(provinceId);
  }

  render() {
    const { t } = this.props;
    const isVietnamese = this.props.i18n.language === 'vi';
    return (
      <div>
        <TextField required label={t('features.Clients.components.BasicInfoSectionShow.viet_office_name')} name="name" maxLength="255" />

        <TextField label={t('features.Clients.components.BasicInfoSectionShow.eng_office_name')} name="nameEng" maxLength="255" validate={isEnglish} />

        <TextField
          required
          label={t('features.Clients.components.BasicInfoSectionShow.tax_identification_number')}
          name="corporateNumber"
          maxLength="10"
          validate={isCorporateNumber}
        />
        <TextField
          label={t('features.Clients.components.BasicInfoSectionShow.social_security_number')}
          name="employerNumber"
          maxLength="7"
          validate={isSocialSecurityNumber}
        />

        <TelFieldTh
          required
          label={t('features.Clients.components.BasicInfoSectionShow.phone_number')}
        />

        <div>
          <SelectField
            required
            label={t('features.Clients.components.BasicInfoSectionShow.province')}
            name="provinceId"
            options={this.state.provinces}
            placeholder={t('features.Clients.components.BasicInfoSectionShow.please_select')}
            validate={isEmpty}
            onChange={this._handleProvinceChange}
          />
        </div>

        <div>
          <SelectField
            required
            label={t('features.Clients.components.BasicInfoSectionShow.subdistricts')}
            name="subdistrictId"
            options={this.state.subdistricts}
            placeholder={t('features.Clients.components.BasicInfoSectionShow.please_select')}
            validate={isEmpty}
          />
        </div>

        <div>
          <TextField label={t('features.Clients.components.BasicInfoSectionShow.address')} type="text" name="address" />
        </div>

        <TextField label={t('features.Clients.components.BasicInfoSectionShow.postal_code')} maxLength="10" validate={isPostalCode} name="postalCode" />

        <SelectField
          required
          label={t('features.Clients.components.BasicInfoSectionShow.regional_tax_office')}
          name="regionalTaxOfficeId"
          options={this.state.regionalTaxOffices}
          placeholder={t('features.Clients.components.BasicInfoSectionShow.please_select_regional_tax_office')}
          validate={isEmpty}
          onChange={regionalTaxOfficeId => {
            this.props.dispatch(formChange(CLIENT_FORM, 'client.taxOfficeId', null));
            const selectedOption = this.state.regionalTaxOffices.find(option => option.value === regionalTaxOfficeId);
            this._handleRegionalTaxOfficeChange(selectedOption?.taxOfficeCode);
          }}
        />

        <SelectField
          required
          label={t('features.Clients.components.BasicInfoSectionShow.management_tax_office')}
          name="taxOfficeId"
          options={this.state.taxOffices}
          placeholder={t('features.Clients.components.BasicInfoSectionShow.please_select_management_tax_office')}
          validate={isEmpty}
        />

        <SelectField
          required
          label={t('features.Clients.components.BasicInfoSectionShow.thai_sso_office')}
          name="ssoOfficeId"
          options={this.state.ssoOffices}
          placeholder="Please select sso office"
          validate={isEmpty}
        />

        <SelectField
          required
          label={t('features.Clients.components.BasicInfoSectionShow.region')}
          name="region"
          options={this.state.regions}
          placeholder="Please select region"
          note={t('features.Clients.components.BasicInfoSectionShow.region_tooltip')}
          validate={isEmpty}
        />

        <Label
          text={t('features.Clients.components.BasicInfoSectionShow.contactname')}
          note={t('features.Clients.components.BasicInfoSectionShow.used_for_documentation')}
        />
        <TextField label={t('features.Clients.components.BasicInfoSectionShow.position')} name="position" required />
        <DoubleTextField
          isReverse={isVietnamese}
          fields={[
            { name: 'representativeFirstName', label: t('features.Clients.components.BasicInfoSectionShow.first_name') },
            { name: 'representativeLastName', label: t('features.Clients.components.BasicInfoSectionShow.last_name') }
          ]}
        />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  provinces: getSelectOptions(state, 'provinces'),
  subdistricts: getSelectOptions(state, 'subdistricts'),
  ssoOffices: getSelectOptions(state, 'ssoOffices'),
  regionalTaxOffices: getSelectOptions(state, 'regionalTaxOffices'),
  taxOffices: getSelectOptions(state, 'taxOffices'),
  values: getFormValues(CLIENT_FORM)(state),
  regions: getSelectOptions(state, 'regions')
});

// Add withTranslation() to be able to change language.
export default connect(mapStateToProps)(withTranslation()(ClientSection));
